import { ILastMinuteDealParams } from "../types";
import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { LastMinuteDealService } from "../../services/last-minute-deal.service";
import { ILastMinuteDeal } from "../../models/LastMinuteDeal";

export const useGetAllLastMinuteDealQuery = (data: ILastMinuteDealParams) => {
  return useQuery<{ items: ILastMinuteDeal[]; total: number }, Error>({
    queryKey: [QUERY_CONSTANTS.GET_ALL_LAST_MINUTE_DEALS, data],
    queryFn: () =>
      LastMinuteDealService.getAll(data.currentPage, data.pageSize).then((res) => res.data),
  });
};

export const useGetLastMinuteDealByIdQuery = (id: string) => {
  return useQuery<ILastMinuteDeal, Error>({
    queryKey: [QUERY_CONSTANTS.GET_LAST_MINUTE_DEAL_BY_ID, id],
    queryFn: () => LastMinuteDealService.getById(id).then((res) => res.data),
    enabled: !!id && id !== "new",
    staleTime: 0,
  });
};
